import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_shangchuanS.svg'
import _imports_1 from '@/assets/sound/play2.png'


const _hoisted_1 = { class: "emotionCommon" }
const _hoisted_2 = { class: "parameterCommon" }
const _hoisted_3 = { class: "upLoadBox" }
const _hoisted_4 = { class: "upLoadBoxInner" }
const _hoisted_5 = { class: "upLoadBox" }
const _hoisted_6 = { class: "upLoadBoxInner" }
const _hoisted_7 = { class: "upLoadBoxTxt" }
const _hoisted_8 = { class: "parameterCommon" }
const _hoisted_9 = { class: "commonSlider" }

import { ref, onMounted,getCurrentInstance } from 'vue'
import slider from '../commonPage/slider.vue'
import {
    Upload,
    CircleCloseFilled,
} from "@element-plus/icons-vue";
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'emotionRefer',
  emits: ['referData'],
  setup(__props, { emit: __emit }) {

const token = Auth.getToken();
const emit = __emit
const upUrl=ref('')
const upFileId=ref('')//上传文件ID
const datalistOne=ref({
    'intensity':'0'
})
const title=ref('')//文件名称
const delupLoad=()=>{
    title.value=''
    upFileId.value=''
    emit('referData',JSON.stringify([upFileId.value,datalistOne.value.intensity]))
}
// 上传文件
const submitUpload = (file: any,) => {
    console.log('提交上传文件')
    console.log(file)
  
    // if (fileText.value == undefined || fileText.value == '' || fileText.value == null) {
    //     ElMessage.error("请上传文件!");
    //     return
    // }
    upFileId.value=''
    const isLtM = file.raw.size / 1024 / 1024;
    // console.log(isLtM)
    if (isLtM > 100) {
        ElMessage.error("请上传100M以内的文件!");
        return false
    }
    const formDatas = new FormData();
    formDatas.append('file',file.raw);
    formDatas.append('businessType','tts');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                upFileId.value=data.data.url
                title.value=file.name
                emit('referData',JSON.stringify([upFileId.value,datalistOne.value.intensity]))
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
const updataNum=(num:number)=>{
    console.log(num)
    datalistOne.value.intensity=num
    emit('referData',JSON.stringify([upFileId.value,datalistOne.value.intensity]))
}
const handleChangeNum=(num:number)=>{
    datalistOne.value.intensity=num
    emit('referData',JSON.stringify([upFileId.value,datalistOne.value.intensity]))
}

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "commonTitle" }, [
        _createElementVNode("span", null, " 参考音频")
      ], -1)),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_upload, {
            class: "upload-demo",
            "show-file-list": false,
            multiple: "",
            "auto-upload": false,
            onChange: submitUpload,
            accept: ".wav,.mp3"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "upLoadBoxLeft" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1),
              _createElementVNode("div", { class: "upLoadBoxTxt" }, " 点击上传参考音频文件 ", -1)
            ])),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, title.value=='']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_icon, {
            color: "#fff",
            size: "18",
            class: "upLoadBoxInnerIcon",
            onClick: _withModifiers(delupLoad, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleCloseFilled))
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "upLoadBoxLeft" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(title.value), 1)
        ])
      ], 512), [
        [_vShow, title.value!='']
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "commonTitle" }, " 参考音频影响强度", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.intensity,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNum
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.intensity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datalistOne.value.intensity) = $event)),
          min: -1,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNum
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})